import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Pagination } from "@material-ui/lab";
import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import ContentTitle from "components/common/ContentTitle";
import LayoutNavbar from "components/common/LayoutNavbar";
import Loading from "components/common/Loading";
import SearchFilterBox from "components/common/SearchFilterBox";
import { StyledTableCell, StyledTableRow } from "components/common/Table";
import useModalLoading from "libs/hooks/useModalLoading";
import usePagination from "libs/hooks/usePagination";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { getPersonalList } from "redux/modules/personalSlice";

const useStyles = makeStyles((theme) => ({
  card: {
    padding: theme.spacing(5),
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    backgroundColor: "#F1F3F9",
    color: "#8898AA",
  },
  tableContainer: {
    marginTop: theme.spacing(4),
  },
  pagination: {
    marginTop: theme.spacing(4),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

function PersonalListPage() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const modalLoading = useModalLoading();
  const [searchText, setSearchText] = useState("");

  const { list, isLoading } = useSelector((state) => state.personal);
  const userID = useSelector((state) => state.auth.userID);

  const { jump, currentData, currentPage, maxPage } = usePagination(
    list || [],
    6
  );
  const dataList = currentData();

  useEffect(() => {
    dispatch(getPersonalList({ agentId: userID }));
  }, [dispatch, userID]);

  const handleOnSearch = (e) => setSearchText(e.target.value);

  const handleClickCancel = () => {
    setSearchText("");
    dispatch(getPersonalList({ keyword: "", agentId: userID }));
  };

  const handleClickSearch = () => {
    dispatch(getPersonalList({ keyword: searchText, agentId: userID }));
    modalLoading.showLoading();
  };

  const handleClickView = (detail) => () => {
    history.push(`/personal-detail/${detail.personalID}`);
  };

  useEffect(() => {
    if (!isLoading) {
      modalLoading.hideLoading();
    }
  }, [modalLoading, isLoading]);

  return (
    <LayoutNavbar title="Agency / User">
      <Paper className={classes.card}>
        <ContentTitle subTitle="Smart Visa holders" title="Personal" />
        <SearchFilterBox
          searchValue={searchText}
          onSearch={handleOnSearch}
          onClickSearch={handleClickSearch}
          onClickCancel={handleClickCancel}
        />
        <ContentTitle subTitle="Search List" subTitleStyle={{ fontSize: 28 }} />
        <TableContainer className={classes.tableContainer}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHead}>PASSPORT</TableCell>
                <TableCell className={classes.tableHead}>FIRST NAME</TableCell>
                <TableCell className={classes.tableHead}>LAST NAME</TableCell>
                <TableCell className={classes.tableHead}>
                  PHONE NUMBER
                </TableCell>
                <TableCell className={classes.tableHead}>ACTION</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {dataList.map((row) => (
                <StyledTableRow key={row.personalID}>
                  <StyledTableCell>{row.passportNumber || "-"}</StyledTableCell>
                  <StyledTableCell>{row.firstname || "-"}</StyledTableCell>
                  <StyledTableCell>{row.lastName || "-"}</StyledTableCell>
                  <StyledTableCell>{row.mobile || "-"}</StyledTableCell>
                  <StyledTableCell>
                    <ColorButton
                      variant="contained"
                      color="info"
                      onClick={handleClickView(row)}
                    >
                      View
                    </ColorButton>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
              {isLoading && dataList.length === 0 && (
                <StyledTableRow>
                  <StyledTableCell colSpan={5}>
                    <Loading />
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <Pagination
          className={classes.pagination}
          page={currentPage}
          count={maxPage}
          color="primary"
          onChange={(__, toPage) => jump(toPage)}
        />
      </Paper>
    </LayoutNavbar>
  );
}

export default PersonalListPage;
